import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 400 448",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 448\" id=\"arrow-left\">\n<title></title>\n<g id=\"arrow-left_icomoon-ignore\">\n</g>\n<path d=\"M384 224v32c0 17-11.25 32-29.25 32h-176l73.25 73.5c6 5.75 9.5 14 9.5 22.5s-3.5 16.75-9.5 22.5l-18.75 19c-5.75 5.75-14 9.25-22.5 9.25s-16.75-3.5-22.75-9.25l-162.75-163c-5.75-5.75-9.25-14-9.25-22.5s3.5-16.75 9.25-22.75l162.75-162.5c6-6 14.25-9.5 22.75-9.5s16.5 3.5 22.5 9.5l18.75 18.5c6 6 9.5 14.25 9.5 22.75s-3.5 16.75-9.5 22.75l-73.25 73.25h176c18 0 29.25 15 29.25 32z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol